import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../../services/exports/Constants';

export default {
  title: {
    [ORDER_METHODS.DELIVERY]: 'Delivery',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Room service',
      [RoomServiceLocationType.TableService]: 'Table service',
    },
  },
  form: {
    doorbell_name: {
      placeholder: 'Door bell name (optional)',
    },
    company_name: {
      placeholder: 'Company name (optional)',
    },
    customer_note: {
      placeholder: 'Delivery instructions (optional)',
    },
    order_instructions: {
      placeholder: 'Enter order instructions...',
    },
  },
};
